import { render, staticRenderFns } from "./eventComp_mode_13.vue?vue&type=template&id=083efc40&scoped=true"
import script from "./eventComp_mode_13.vue?vue&type=script&lang=js"
export * from "./eventComp_mode_13.vue?vue&type=script&lang=js"
import style0 from "./eventComp_mode_13.vue?vue&type=style&index=0&id=083efc40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083efc40",
  null
  
)

export default component.exports